export default "__VITE_ASSET__DIWlXSUp__"